import { useEffect, useState } from "react"

import { AdminBonus2Service } from "services/bonus/AdminBonus2Service"
import { TagAudience } from "services/bonus/type"

export const useTagAudience = (
  tagSlugs: string[],
  tenant: string,
  enabled: boolean
): { audience: TagAudience | undefined; loading: boolean } => {
  const [audience, setAudience] = useState<TagAudience | undefined>(undefined)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!enabled || tagSlugs.length === 0) {
      setAudience(undefined)
      return
    }

    let cancelled = false
    setLoading(true)
    AdminBonus2Service.getTagAudience(tagSlugs, tenant)
      .then((res) => {
        if (!cancelled) setAudience(res)
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [enabled, tagSlugs, tenant])

  return { audience, loading }
}
